// actionTypes.js
export const FETCH_FEE_PAYMENT_REQUEST = 'FETCH_FEE_PAYMENT_REQUEST';
export const FETCH_FEE_PAYMENT_SUCCESS = 'FETCH_FEE_PAYMENT_SUCCESS';
export const FETCH_FEE_PAYMENT_FAILURE = 'FETCH_FEE_PAYMENT_FAILURE';
